import CreateMeasureModal from '@/src/features/iso-suite/measures/create-measure/CreateMeasureModal'
import { Button, Text, useDisclosure } from '@chakra-ui/react'
import type { FC } from 'react'

type EmberActionType = 'create_measure'

type EmberAction = { type: string; functionArguments: string; locationId?: number }

export interface IProposedUserAction {
  action: EmberAction
  readyToShow: boolean
}

export const EmberActionButton: FC<{ action: EmberAction }> = ({ action }) => {
  const { type, functionArguments: args } = action
  let locationId: number | undefined = undefined

  if (type === 'create_measure') {
    locationId = action.locationId
  }

  const createMeasureModal = useDisclosure()

  const actionsMap = {
    create_measure: {
      text: 'Maßnahme erstellen',
      onClick: createMeasureModal.onOpen,
    },
  }

  const { text, onClick } = actionsMap[type]

  return (
    <>
      <Button
        style={{
          borderImageSlice: 1,
          borderImageSource: 'linear-gradient(to left, #82FF5F, #0661E1)',
          borderWidth: '1px',
          borderRadius: '8px',
          width: '100%',
        }}
        _hover={{ backgroundColor: '#F4F9FF' }}
        _focus={{}}
        onClick={onClick}
        padding={'0px'}
        bg='white'
      >
        <Text color={'#0461E0'} fontSize={'12px'} letterSpacing={'0.24px'}>
          {text}
        </Text>
      </Button>
      {createMeasureModal.isOpen && (
        <CreateMeasureModal
          isOpen={createMeasureModal.isOpen}
          onClose={createMeasureModal.onClose}
          data={{ ...JSON.parse(args), locationId }}
        />
      )}
    </>
  )
}
